import IMG from "../../assets/img/Img"
import { Button } from "../tag/Button"
import { ButtonWrap } from "../tag/CustomTag";
import { Switch } from "../tag/Switch";
import { setDefaultDate } from "../utils/Date";

export const FeederSchedulePopup = ({ feedSchedule, viewDetail, toggleDelYn, updateFeedSchedule, deleteFeedSchedule, transmitData, onClose }) => {  
    
    return (
        <div>
            <h2 className="mb-5 text-[1.3rem] font-bold">사료 공급 스케줄</h2>
            <table className="w-full mb-5">
                <thead>
                    <tr className="h-9 bg-[#0092B8] text-white text-[0.85rem]">
                        <th>예약시간</th>
                        <th>예약정보</th>
                        <th>사용여부</th>
                        <th>작업</th>
                    </tr>
                </thead>
                <tbody className="text-center">
                    {feedSchedule.length > 0 ?
                        feedSchedule.map((item, index) => (
                            <tr key={item.NO || index} className="text-[0.85rem] border-b border-[#dfdfdf]">
                                <td>
                                    {setDefaultDate(new Date(item.SCHEDULE_TIME))}
                                </td>
                                <td>                                    
                                    <div className="flex justify-center items-center">
                                        <Button onClick={() => viewDetail(item.NO)} style={{ backgroundImage: `url(${IMG.EYE_ICON})` }} className="w-6 h-6 bg-no-repeat bg-center"></Button>
                                    </div>
                                </td>
                                <td className="h-9 flex justify-center items-center">
                                    <Switch enabled={item.DEL_YN === "N" ? true : false} onChange={(value) => toggleDelYn(item.NO, value)}/>
                                </td>
                                <td>
                                    <div className="flex justify-center items-center gap-3">
                                        <Button onClick={() => updateFeedSchedule(item.NO)} style={{ backgroundImage: `url(${IMG.PENCIL_SQUARE_ICON})` }} className="w-6 h-6 bg-no-repeat bg-center"></Button>
                                        <Button onClick={() => deleteFeedSchedule(item.NO)} style={{ backgroundImage: `url(${IMG.TRASH_ICON})` }} className="w-6 h-6 bg-no-repeat bg-center"></Button>
                                    </div>
                                </td>
                            </tr>
                        ))
                        :
                        <tr className="h-9 text-[0.85rem] border-b border-[#dfdfdf]"><td colSpan={4}>스케줄이 없습니다.</td></tr>}
                </tbody>
            </table>
            <ButtonWrap>
                <Button
                    onClick={onClose}
                    className="w-20 h-8 bg-[#F54900] rounded text-white font-bold text-[0.9rem]"
                >
                    닫기
                </Button>
                <Button onClick={transmitData} className="w-20 h-8 bg-[#0092B8] rounded text-white font-bold text-[0.9rem]">
                    전송
                </Button>
            </ButtonWrap>
        </div>
    )
}